
import { Component, Vue } from "vue-property-decorator";
import api from "@/network/api";
import { AxiosResponse } from "axios";
import { eventBus } from "../../eventBus";

@Component
export default class MobileNotifications extends Vue {
  private notifications: any = [];

  created() {
    api.get("notifications").then((res: AxiosResponse) => {
      this.notifications = res.data.notifications;
    });
  }

  readNotification(item: any) {
    if (!item.is_read) {
      api
        .put("notifications/" + item.id)
        .then()
        .catch();
      // eslint-disable-next-line @typescript-eslint/camelcase
      item.is_read = true;
      eventBus.$emit("reloadNotifications");
    }
    if (item.link) {
      this.$router.push(item.link);
    }
  }
}
